import {createClient} from '@supabase/supabase-js';

const supabaseURL = 'https://qzzhzpmsmlwidnfsvexm.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InF6emh6cG1zbWx3aWRuZnN2ZXhtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njg5MDY2MDgsImV4cCI6MjA4NDQ4MjYwOH0.EkjEwDFXz1VyvBdJNZN0cl9x6OLQuRXAeOfgtG37JB4'

export const supabase = createClient(supabaseURL, supabaseKey);